import { render, staticRenderFns } from "./AddNewCustomer.vue?vue&type=template&id=325693c6&scoped=true&"
import script from "./AddNewCustomer.vue?vue&type=script&lang=js&"
export * from "./AddNewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCustomer.vue?vue&type=style&index=0&id=325693c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325693c6",
  null
  
)

export default component.exports